/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getByIdEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService',
  rpcName: 'getById',
  auth: 'external',
  fingerprint: '8wmW0arbCOWji0pkX9hiMu-ymnNyhEw2',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getByLanguageAndPagePathEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService',
  rpcName: 'getByLanguageAndPagePath',
  auth: 'external',
  fingerprint: 'cGNdIkKTAlWji0pkX9hiMpwP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};